
import { defineComponent, PropType } from 'vue';
import { IOrder } from '@/types/models';
import utils from '@/utils';

export default defineComponent({
  props: {
    order: {
      type: Object as PropType<IOrder>,
      required: true,
    },
  },
  methods: {
    getChannel() {
      return utils.getPayChannel(this.order.channel);
    },

    getUrl() {
      return utils.getResourceUrl(this.order.resourceType, this.order.resourceId);
    },
  },
});
